import { render, staticRenderFns } from "./WithdrawnTabComponent.vue?vue&type=template&id=65edcaf3&"
import script from "./WithdrawnTabComponent.vue?vue&type=script&lang=js&"
export * from "./WithdrawnTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports